module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "create-tag"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Criar Nova Tag")])]), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('name')
    }
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Nome da Tag")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "tagName",
      "name": "name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('name')),
      expression: "errors.has('name')"
    }],
    key: "name",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('name')))])])], 1), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('color')
    }
  }, [_c('div', {
    staticClass: "color-input"
  }, [_c('div', {
    staticClass: "color-picker"
  }, _vm._l((_vm.tagColors), function(color) {
    return _c('div', {
      staticClass: "color-box",
      class: color.class,
      style: ({
        "background": "#" + color.hex
      }),
      on: {
        "click": function($event) {
          return _vm.setColor(color)
        }
      }
    })
  }), 0), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "color",
      "name": "color",
      "type": "hidden"
    },
    domProps: {
      "value": _vm.color()
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('color')),
      expression: "errors.has('color')"
    }],
    key: "color",
    staticClass: "help-block"
  }, [_vm._v("Você precisa selecionar uma cor")])])], 1)])]), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-gray",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancelar")]), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.create
    }
  }, [_vm._v("Criar")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3586e025!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/contacts/create_tag_modal.vue
// module id = 1071
// module chunks = 1